import { ArrowUpRight, CircleNotch, Globe, Trash } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

import RenderIf from "common/components/RenderIf";
import { Button } from "common/components/ui/Button";
import { Tag } from "common/components/ui/Tag";

import useAgencyDomain from "../../../datahooks/useAgencyDomain";
import useAgencyDomainConfiguration from "../../../datahooks/useAgencyDomainConfiguration";
import useWhitelabelPreviewUrl from "../../../hooks/useWhitelabelPreviewUrl";

export default function DomainItem({
  domainName,
  onDelete,
}: {
  domainName: string;
  onDelete?: () => void;
}) {
  const { agencyDomain, isLoadingAgencyDomain } = useAgencyDomain(domainName);
  const { agencyDomainConfiguration, isLoadingAgencyDomainConfiguration } =
    useAgencyDomainConfiguration(domainName);
  const { whitelabelPreviewUrl, refreshWhitelabelPreviewUrl } =
    useWhitelabelPreviewUrl(domainName);

  const isLive =
    agencyDomain?.verified &&
    agencyDomainConfiguration &&
    !agencyDomainConfiguration.misconfigured;

  return (
    <div className="flex justify-between">
      <div className="flex items-center gap-x-1">
        <Globe size={16} />
        <span className="text-xs-medium text-black-500">{domainName}</span>
        <Button size="xs" intent="iconOnly" variant="ghost-black" asChild>
          <Link
            to={whitelabelPreviewUrl}
            onClick={refreshWhitelabelPreviewUrl}
            target="_blank"
          >
            <ArrowUpRight />
          </Link>
        </Button>
        <RenderIf
          condition={
            isLoadingAgencyDomain || isLoadingAgencyDomainConfiguration
          }
        >
          <CircleNotch className="animate-spin" />
        </RenderIf>
        <RenderIf condition={isLive}>
          <Tag size="sm" variant="success">
            Live
          </Tag>
        </RenderIf>
      </div>
      {onDelete && (
        <Button
          size="xs"
          intent="iconOnly"
          variant="ghost-black"
          onClick={onDelete}
          aria-label="delete domain"
        >
          <Trash />
        </Button>
      )}
    </div>
  );
}
